import { render, staticRenderFns } from "./CorregirCumplimientos.vue?vue&type=template&id=0ecd1208&scoped=true&"
import script from "./CorregirCumplimientos.vue?vue&type=script&lang=ts&"
export * from "./CorregirCumplimientos.vue?vue&type=script&lang=ts&"
import style0 from "./CorregirCumplimientos.vue?vue&type=style&index=0&id=0ecd1208&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecd1208",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0ecd1208', component.options)
    } else {
      api.reload('0ecd1208', component.options)
    }
    module.hot.accept("./CorregirCumplimientos.vue?vue&type=template&id=0ecd1208&scoped=true&", function () {
      api.rerender('0ecd1208', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/CertificadorBHP/CorregirCumplimientos.vue"
export default component.exports